import { MdOutlineCurrencyExchange } from "react-icons/md";
import { TbPlus, TbMinus } from "react-icons/tb";
import { useCallback, useEffect } from "react";
import toast from "react-hot-toast";

import PersianNumber from "../../utils/PersianNumber/PersianNumber";
import useModalTimer from "../../hooks/useModalTimer";

const MobileListUi = ({
  roleName,
  timerStatus,
  index,
  _item,
  data,
  setData,
  resultModal,
  setResultModal,
  orderModal,
  setOrderModal,
  statePrice,
  setStatePrice,
  handlePriceChange,
  stateWeight,
  setStateWeight,
  handleWeightChange,
  stateTotal,
  setStateTotal,
  handleTotalChange,
  description,
  setDescription,
  addCommas,
  type,
  setType,
  handlePostTransaction,
  setProduct_name,
  setCustomeruser,
  userInfo,
  setBos,
  setIs_orderi,
  transactionId,
  //* Timer Of Order
  setIsTimerOn,
  handleStartTimer,
  //* Update Product
  handleChangeBuyPrice,
  handleChangeSellPrice,
  //* Is Price Close
  handleChangeBuyClosePriceProduct,
  handleChangeSellClosePriceProduct,
  //* Is Orders Close
  isOrdersClose,
  //* Is Orderi Close
  isOrderiClose,
}) => {
  //* Timer Of Order
  useEffect(() => {
    const storedExpiryTime = localStorage.getItem("timerExpiryTime");
    if (storedExpiryTime) {
      const remainingTime = storedExpiryTime - new Date().getTime();
      if (remainingTime > 0) {
        setIsTimerOn(true);
        setTimeout(() => {
          localStorage.removeItem("timerExpiryTime");
          setIsTimerOn(false);
        }, remainingTime);
      }
    }
  }, []);

  //* تابع بستن مودال
  const closeModal = useCallback(() => {
    setStatePrice("");
    setStateWeight("");
    setStateTotal("");
    setDescription("");
    setData("");
    setType("");
    setOrderModal(true);
    setResultModal(false);
    setIsTimerOn(false);
    localStorage.removeItem("timerExpiryTime");
  }, [
    setStatePrice,
    setStateWeight,
    setStateTotal,
    setDescription,
    setData,
    setType,
    setOrderModal,
    setResultModal,
    setIsTimerOn,
  ]);

  //* تشخیص باز بودن مودال
  const isModalOpen = _item?.id === data?.id && orderModal;

  //* تایمر ۳۰ ثانیه‌ای برای بستن خودکار مودال (از لحظه باز شدن مدال)
  const { timeLeft } = useModalTimer(isModalOpen, closeModal, 30000);

  //* Handle Set Order By User
  const setOrderByUser = (_item, orderType) => {
    if (!isOrdersClose) {
      setStateWeight("");
      setStateTotal("");
      setDescription("");
      setData("");
      setType("");
      setStatePrice(orderType === "buy" ? _item?.buy_price : _item?.sell_price);
      setData(_item);
      setType(orderType);
    } else {
      toast.error("در حال حاضر امکان ثبت سفارش وجود ندارد");
    }
  };

  return (
    <>
      <tr key={index} className="hover:bg-boxColor w-full relative h-20">
        {/* Number */}
        <td className="py-4 pr-2">
          <div
            className={`${
              _item.id === data.id ? "hidden" : "flex"
            } items-center text-center justify-center 
              font-medium text-xs text-slate-200
              animate__animated animate__fadeIn animate__fast`}
          >
            {index + 1}
          </div>
        </td>
        {/* Product Name */}
        <td className="py-4">
          <div
            className={`${
              _item.id === data.id ? "hidden" : "flex"
            } items-center text-center justify-center 
              font-medium text-xs text-slate-200
              animate__animated animate__fadeIn animate__fast`}
          >
            {_item.name}
          </div>
        </td>
        {/* Green Prices */}
        <td className="py-4">
          <div className="flex flex-col justify-center items-center space-y-2">
            {/* Price */}
            <div className="text-greenNeon flex justify-center items-center">
              {/* Increase */}
              {roleName === "ADMIN" && (
                <>
                  {_item.buy_price === -1 ? null : (
                    <span
                      className="ml-1 cursor-pointer"
                      onClick={() => {
                        handleChangeBuyPrice(
                          _item?.id,
                          "buyIncrement",
                          _item?.tag
                        );
                      }}
                    >
                      <TbPlus />
                    </span>
                  )}
                </>
              )}
              {/* Price */}
              <div
                onClick={() => setOrderByUser(_item, "buy")}
                className={`${
                  _item.id === data.id ? "hidden" : "flex"
                } justify-center tracking-wide font-medium
              cursor-pointer text-sm
              animate__animated animate__fadeIn animate__fast`}
              >
                {_item.buy_price === -1 ? (
                  "-"
                ) : (
                  <PersianNumber
                    value={_item.buy_price}
                    thousandSeparator=","
                  />
                )}
              </div>
              {/* Decrease */}
              {roleName === "ADMIN" && (
                <>
                  {_item.buy_price === -1 ? null : (
                    <span
                      className="mr-1 cursor-pointer"
                      onClick={() => {
                        handleChangeBuyPrice(
                          _item?.id,
                          "buyDecrement",
                          _item?.tag
                        );
                      }}
                    >
                      <TbMinus />
                    </span>
                  )}
                </>
              )}
            </div>
            {/* Is Close Text */}
            {roleName === "ADMIN" && (
              <>
                <div
                  className={`${
                    _item?.is_buy_closed ? "text-redNeon" : "text-greenNeon"
                  } cursor-pointer text-sm`}
                >
                  {_item?.is_buy_closed ? (
                    <p
                      onClick={() =>
                        handleChangeBuyClosePriceProduct(
                          _item?.id,
                          false,
                          _item?.periority,
                          _item?.is_sell_closed,
                          _item?.is_market_close
                        )
                      }
                    >
                      قیمت خرید بسته
                    </p>
                  ) : (
                    <p
                      onClick={() =>
                        handleChangeBuyClosePriceProduct(
                          _item?.id,
                          true,
                          _item?.periority,
                          _item?.is_sell_closed,
                          _item?.is_market_close
                        )
                      }
                    >
                      قیمت خرید باز
                    </p>
                  )}
                </div>
              </>
            )}
          </div>
        </td>
        {/* Red Prices */}
        <td className="py-4">
          <div className="flex flex-col justify-center items-center space-y-2">
            {/* Price */}
            <div className="text-redNeon flex justify-center items-center">
              {/* Increase */}
              {roleName === "ADMIN" && (
                <>
                  {_item.sell_price === -1 ? null : (
                    <span
                      className="ml-1 cursor-pointer"
                      onClick={() => {
                        handleChangeSellPrice(
                          _item?.id,
                          "sellIncrement",
                          _item?.tag
                        );
                      }}
                    >
                      <TbPlus />
                    </span>
                  )}
                </>
              )}
              {/* Price */}
              <div
                onClick={() => setOrderByUser(_item, "sell")}
                className={`${
                  _item.id === data.id ? "hidden" : "flex"
                } justify-center tracking-wide font-medium
                cursor-pointer text-sm
                animate__animated animate__fadeIn animate__fast`}
              >
                {_item.sell_price === -1 ? (
                  "-"
                ) : (
                  <PersianNumber
                    value={_item.sell_price}
                    thousandSeparator=","
                  />
                )}
              </div>
              {/* Decrease */}
              {roleName === "ADMIN" && (
                <>
                  {_item.sell_price === -1 ? null : (
                    <span
                      className="mr-1 cursor-pointer"
                      onClick={() => {
                        handleChangeSellPrice(
                          _item?.id,
                          "sellDecrement",
                          _item?.tag
                        );
                      }}
                    >
                      <TbMinus />
                    </span>
                  )}
                </>
              )}
            </div>
            {/* Is Close Text */}
            {roleName === "ADMIN" && (
              <>
                <div
                  className={`${
                    _item?.is_sell_closed ? "text-redNeon" : "text-greenNeon"
                  } cursor-pointer text-sm`}
                >
                  {_item?.is_sell_closed ? (
                    <p
                      onClick={() =>
                        handleChangeSellClosePriceProduct(
                          _item?.id,
                          false,
                          _item?.periority,
                          _item?.is_buy_closed,
                          _item?.is_market_close
                        )
                      }
                    >
                      قیمت فروش بسته
                    </p>
                  ) : (
                    <p
                      onClick={() =>
                        handleChangeSellClosePriceProduct(
                          _item?.id,
                          true,
                          _item?.periority,
                          _item?.is_buy_closed,
                          _item?.is_market_close
                        )
                      }
                    >
                      قیمت فروش باز
                    </p>
                  )}
                </div>
              </>
            )}
          </div>
        </td>
        {/* Last Update */}
        <td className="py-4">
          <div
            className={`${
              _item.id === data.id ? "hidden" : "flex"
            } justify-center text-gray-400 text-xs
            animate__animated animate__fadeIn animate__fast`}
          >
            {_item.last_update_time_ago}
          </div>
        </td>
        {/* Modal */}
        {_item?.id === data?.id && (
          <>
            <td>
              <div
                className="flex bg-black bg-opacity-40 fixed lg:mr-40
            inset-0 items-center w-full z-50 mr-auto h-screen
            animate__animated animate__fadeIn animate__fast"
              >
                <div
                  className="flex flex-col -mt-5 w-11/12 sm:w-5/6
                lg:w-12/12 max-w-2xl mx-auto rounded-lg border-2 border-boxColor"
                >
                  {/* Order Modal */}
                  {orderModal && (
                    <>
                      {/* Title */}
                      <div className="flex justify-center items-center w-full p-6 bg-boxColor relative">
                        <p className="text-base font-medium text-gray-200">
                          سفارش{" "}
                          <span
                            className={`${
                              type === "buy" ? "text-greenNeon" : "text-redNeon"
                            }`}
                          >
                            {type === "buy" ? "خرید" : "فروش"}
                          </span>{" "}
                          برای " {_item?.name} "
                        </p>
                        {/* نمایش شمارش معکوس */}
                        <span
                          className={`absolute left-4 text-sm font-bold ${
                            timeLeft <= 10 ? "text-redNeon" : "text-yellow-400"
                          }`}
                        >
                          ⏱ {timeLeft} ثانیه
                        </span>
                      </div>
                      {/* Confirmation Of Order */}
                      <div
                        className="grid grid-cols-2 gap-y-4 justify-items-center pb-4
                      items-center w-full bg-boxColor text-slate-200 text-base"
                      >
                        {/* Price */}
                        {statePrice ? (
                          <span className="flex flex-col items-center space-y-1">
                            <span>{_item.tag === "S" ? "قیمت" : "مظنه"}</span>
                            <span>
                              <PersianNumber
                                value={statePrice}
                                thousandSeparator=","
                              />
                            </span>
                          </span>
                        ) : (
                          <span className="flex flex-col items-center space-y-1">
                            <span>{_item.tag === "S" ? "قیمت" : "مظنه"}</span>
                            <span>-</span>
                          </span>
                        )}
                        {/* Weight */}
                        {stateWeight ? (
                          <span className="flex flex-col items-center space-y-1">
                            <span>
                              {_item.tag === "S" ? "تعداد" : "مقدار (گرم)"}
                            </span>
                            <span>
                              <PersianNumber
                                value={stateWeight}
                                thousandSeparator=","
                              />
                            </span>
                          </span>
                        ) : (
                          <span className="flex flex-col items-center space-y-1">
                            <span>
                              {_item.tag === "S" ? "تعداد" : "مقدار (گرم)"}
                            </span>
                            <span>-</span>
                          </span>
                        )}
                        {/* Total */}
                        {stateTotal ? (
                          <span className="flex flex-col items-center">
                            <span>جمع کل</span>
                            <span>
                              <PersianNumber
                                value={stateTotal}
                                thousandSeparator=","
                              />
                            </span>
                          </span>
                        ) : (
                          <span className="flex flex-col items-center">
                            <span>جمع کل</span>
                            <span>-</span>
                          </span>
                        )}
                        {/* Description */}
                        {description ? (
                          <span
                            className="flex flex-col items-center
                          w-32 overflow-hidden text-ellipsis whitespace-nowrap"
                          >
                            <span>توضیحات</span>
                            <span>{description}</span>
                          </span>
                        ) : (
                          <span className="flex flex-col items-center">
                            <span>توضیحات</span>
                            <span>-</span>
                          </span>
                        )}
                      </div>
                      <span className="border-b-2 border-boxColor" />

                      {!resultModal ? (
                        // *Inputs - Button
                        <>
                          <div className="w-full px-6 py-5 bg-mainBackground relative">
                            <form onSubmit={handlePostTransaction}>
                              {/* Inputs */}
                              <div className="flex flex-col w-full">
                                {/* Order Icon */}
                                {type === "buy" && (
                                  <>
                                    {_item.buy_price !== statePrice && (
                                      <span className="absolute px-2 py-1 rounded-full top-2 left-1 flex items-center text-slate-300">
                                        <div className="group flex relative">
                                          <MdOutlineCurrencyExchange
                                            size={18}
                                            className="animate-spin-slow"
                                          />
                                          <span
                                            className="group-hover:opacity-100 transition-opacity 
                                  px-1 text-sm text-slate-300 rounded-md absolute left-1/2 
                                  -translate-x-1/2 translate-y-full opacity-0 m-1 mx-auto"
                                          >
                                            اردری
                                          </span>
                                        </div>
                                      </span>
                                    )}
                                  </>
                                )}
                                {type === "sell" && (
                                  <>
                                    {_item.sell_price !== statePrice && (
                                      <span
                                        className="absolute px-2 py-1 rounded-full top-2
                              left-1 flex items-center text-slate-300"
                                      >
                                        <div className="group flex relative">
                                          <MdOutlineCurrencyExchange
                                            size={18}
                                            className="animate-spin-slow"
                                          />
                                          <span
                                            className="group-hover:opacity-100 transition-opacity 
                                  px-1 text-sm text-slate-300 rounded-md absolute left-1/2 
                                  -translate-x-1/2 translate-y-full opacity-0 m-1 mx-auto"
                                          >
                                            اردری
                                          </span>
                                        </div>
                                      </span>
                                    )}
                                  </>
                                )}

                                <span>
                                  {/* Price */}
                                  <span className="w-full">
                                    <label
                                      htmlFor="price"
                                      className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                                    >
                                      {_item.tag === "s" ? "قیمت" : "مظنه"}
                                    </label>
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      readOnly={isOrderiClose}
                                      onClick={() => {
                                        if (isOrderiClose) {
                                          toast.error(
                                            "در حال حاضر امکان ویرایش قیمت وجود ندارد"
                                          );
                                        } else {
                                        }
                                      }}
                                      name="price"
                                      value={
                                        statePrice === -1
                                          ? ""
                                          : statePrice === ""
                                          ? statePrice + statePrice
                                          : addCommas(statePrice)
                                      }
                                      onChange={(e) => {
                                        handlePriceChange(_item, e);
                                      }}
                                      className={`p-2 mb-2 bg-transparent border-2
                     border-slate-600 w-full rounded-md focus:right-0 
                     focus:outline-none tracking-wide text-slate-400
                     ${
                       type === "buy"
                         ? "focus:border-greenNeon focus:text-greenNeon"
                         : "focus:border-redNeon focus:text-redNeon"
                     }
                   `}
                                    />
                                  </span>
                                  {/* Weight */}
                                  <span className="w-full">
                                    <label
                                      htmlFor="weight"
                                      className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                                    >
                                      {_item.tag === "S"
                                        ? "تعداد"
                                        : "مقدار (گرم)"}
                                    </label>
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      name="weight"
                                      value={stateWeight}
                                      onChange={(e) => {
                                        handleWeightChange(_item, e);
                                      }}
                                      className={`p-2 mb-2 bg-transparent border-2
                     border-slate-600 w-full rounded-md focus:right-0 
                     focus:outline-none tracking-wide text-slate-400
                   ${
                     type === "buy"
                       ? "focus:border-greenNeon focus:text-greenNeon"
                       : "focus:border-redNeon focus:text-redNeon"
                   }`}
                                    />
                                  </span>
                                  {/* Total */}
                                  <span className="w-full">
                                    <label
                                      htmlFor="total"
                                      className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                                    >
                                      جمع کل
                                    </label>
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      name="total"
                                      value={addCommas(stateTotal)}
                                      onChange={(e) => {
                                        handleTotalChange(_item, e);
                                      }}
                                      className={`p-2 mb-2 bg-transparent border-2
                      border-slate-600 w-full rounded-md
                      focus:right-0 focus:outline-none tracking-wide
                     text-slate-400 
                     ${
                       type === "buy"
                         ? "focus:border-greenNeon focus:text-greenNeon"
                         : "focus:border-redNeon focus:text-redNeon"
                     }`}
                                    />
                                  </span>
                                  {/* Description */}
                                  <span className="w-full">
                                    <label
                                      htmlFor="description"
                                      className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                                    >
                                      توضیحات
                                    </label>
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      name="description"
                                      value={description ? description : ""}
                                      onChange={(e) =>
                                        setDescription(e.target.value)
                                      }
                                      className={`p-2 mb-2 bg-transparent border-2
                      border-slate-600 w-full rounded-md
                      focus:right-0 focus:outline-none tracking-wide
                     text-slate-400
                     ${
                       type === "buy"
                         ? "focus:border-greenNeon focus:text-greenNeon"
                         : "focus:border-redNeon focus:text-redNeon"
                     }`}
                                    />
                                  </span>
                                  {/* Other Items To Send */}
                                  <div>
                                    {setProduct_name(_item.name)}
                                    {setCustomeruser(userInfo[0]?.id)}
                                    {type === "buy" ? setBos("B") : setBos("S")}
                                    {setIs_orderi(
                                      _item.buy_price !== statePrice
                                        ? true
                                        : false
                                    )}
                                  </div>
                                </span>
                              </div>
                              {/* Button */}
                              <span className="flex justify-center w-full mt-5">
                                <button
                                  type="button"
                                  className="text-slate-300 text-base tracking-wider mx-4"
                                  onClick={closeModal}
                                >
                                  لغو
                                </button>
                                <button
                                  onClick={handleStartTimer}
                                  type="submit"
                                  className={`${
                                    type === "buy"
                                      ? "bg-green-500 hover:bg-green-700"
                                      : "bg-red-500 hover:bg-red-700"
                                  } rounded-full px-3 py-0.5 mx-2
                        tracking-wider text-base text-white
                        transition-all duration-100 ease-linear
                        hover:transition-all hover:duration-100 hover:ease-linear`}
                                >
                                  {type === "buy" ? "خرید" : "فروش"}
                                </button>
                              </span>
                            </form>
                          </div>
                        </>
                      ) : (
                        //* Text - Timer
                        <>
                          <div className="w-full px-6 py-5 bg-mainBackground">
                            {transactionId ? (
                              <>
                                <div
                                  className="flex flex-col justify-between items-center w-full h-full space-y-5
                              text-slate-300 text-base animate__animated animate__fadeIn animate__fast"
                                >
                                  <span className="flex flex-col justify-around items-center w-full space-y-2">
                                    {/* Text */}
                                    <span
                                      className={`${
                                        type === "buy"
                                          ? "text-greenNeon"
                                          : "text-redNeon"
                                      }
                                font-bold text-center tracking-wide`}
                                    >
                                      {type === "buy" ? "خرید " : "فروش "}
                                      <span className="text-slate-300">
                                        شما به حالت انتظار تغییر پیدا کرد!
                                      </span>
                                    </span>
                                    {/* Transaction Id */}
                                    <span className="font-medium flex tracking-wider text-zinc-300">
                                      <span>شماره سفارش : </span>
                                      <span>#{transactionId}</span>
                                    </span>
                                  </span>

                                  {/* Button */}
                                  <span className="w-3/12 flex justify-center ">
                                    <button
                                      onClick={closeModal}
                                      className="rounded-full px-3 py-0.5 mx-2
                                tracking-wider text-base text-white 
                                bg-green-500 hover:bg-green-700
                                transition-all duration-100 ease-linear
                                hover:transition-all hover:duration-100 hover:ease-linear"
                                    >
                                      بستن
                                    </button>
                                  </span>
                                </div>
                              </>
                            ) : (
                              <>
                                <div
                                  className="flex flex-col justify-center items-center w-full h-full
                          space-y-5 animate__animated animate__fadeIn animate__fast"
                                >
                                  <span
                                    className="flex items-center justify-center 
                            w-full text-slate-300 text-base font-bold text-center"
                                  >
                                    <span>
                                      سفارش شما ثبت نگردید، لطفا دوباره تلاش
                                      کنید!
                                    </span>
                                  </span>
                                  {/* Button */}
                                  <span className="w-3/12 flex justify-center ">
                                    <button
                                      onClick={closeModal}
                                      className="rounded-full px-3 py-0.5 mx-2
                              tracking-wider text-base text-white 
                              bg-green-500 hover:bg-green-700
                              transition-all duration-100 ease-linear
                              hover:transition-all hover:duration-100 hover:ease-linear"
                                    >
                                      بستن
                                    </button>
                                  </span>
                                </div>
                              </>
                            )}
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </td>
          </>
        )}
      </tr>
    </>
  );
};

export default MobileListUi;